<template>
  <div
    class="h-screen flex w-full bg-white vx-row no-gutter items-center justify-center relative"
  >
    <div class="absolute top-32 right-0 md:block lg:block hidden">
      <img
        src="./../../assets/images/bg-des/career-dots.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute bottom-32 left-0 md:block lg:block hidden">
      <img
        src="./../../assets/images/bg-des/CD-dots2.svg"
        alt="Dots"
        class=""
      />
    </div>
    <div class="absolute top-1/4 right-1/4 md:block lg:block hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>
    <div class="absolute top-1/2 left-20 md:block lg:block hidden">
      <img src="./../../assets/images/bg-des/elli.svg" alt="Dots" class="" />
    </div>

    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 absolute">
      <b-card no-body class="bg-secondary border-0 mb-0 p-0">
        <b-card-body class="lg:flex md:flex p-0 fullpage-bgcolor">
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:flex md:flex items-center justify-center"
          >
            <img src="@/assets/images/login.png" alt="login" class="mx-auto" />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full bg-white">
            <div class="p-4">
              <validation-observer ref="formValidator">
                <div>
                  <div class="mb-3">
                    <h4 class="mb-2 text-xl font-medium">Enter New Password</h4>
                    <p class="text-lg">Please enter your new password</p>
                  </div>

                  <el-form ref="ruleForms" :model="ruleForm" :rules="rules">
                    <div class="relative">
                      <div class="mb-10">
                        <el-form-item prop="password">
                          <el-input
                            alternative
                            class="mb-3"
                            name="Password"
                            placeholder="New Password"
                            v-model="ruleForm.password"
                            :type="passwordFieldType1"
                          >
                          </el-input>
                        </el-form-item>
                        <div
                          class="absolute flex top-3 right-0"
                          @click="switchVisibility(1)"
                        >
                          <feather-icon
                            icon="EyeOffIcon"
                            svgClasses="w-4 h-4 mr-2"
                            v-if="passwordFieldType1 === 'password'"
                          />
                          <feather-icon
                            v-else
                            icon="EyeIcon"
                            svgClasses="w-4 h-4 mr-2 "
                          />
                        </div>
                      </div>
                      <div class="relative">
                        <el-form-item prop="Passwordconfirm">
                          <el-input
                            alternative
                            class="mb-3"
                            name="Confirm Password"
                            placeholder="Confirm Password"
                            v-model="ruleForm.Passwordconfirm"
                            :type="passwordFieldType2"
                          >
                          </el-input>
                        </el-form-item>
                        <div
                          class="absolute flex top-3 right-0"
                          @click="switchVisibility(2)"
                        >
                          <feather-icon
                            icon="EyeOffIcon"
                            svgClasses="w-4 h-4 mr-2 "
                            v-if="passwordFieldType2 === 'password'"
                          />
                          <feather-icon
                            v-else
                            icon="EyeIcon"
                            svgClasses="w-4 h-4 mr-2 "
                          />
                        </div>
                      </div>
                    </div>
                  </el-form>

                  <div class="flex justify-between mt-4">
                    <base-button
                      type="primary"
                      :disabled="
                        !(ruleForm.password && ruleForm.Passwordconfirm)
                      "
                      class="w-2/5 mb-2"
                      @click="handleSubmit('ruleForms')"
                      >Submit</base-button
                    >
                  </div>
                </div>
              </validation-observer>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import OTP from "./components/OTP.vue";
export default {
  data() {
    return {
      userCred: "",
      otp: "",

      rememberMe: false,
      Passwordreset: "",
      newpasswordpage: false,
      passwordFieldType1: "password",
      passwordFieldType2: "password",
      ruleForm: {
        password: "",
        Passwordconfirm: "",
      },
      role: this.$route.query.role || "",
      rules: {
        password: [
          {
            required: true,
            message: "Please Enter Password",
            trigger: "change",
          },
          {
            trigger: "change",
            message:
              "Password must be at least 8 character long and include at least 1 digit,1 lowercase,1 uppercasse, 1 special character.",
            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/,
          },
        ],
        Passwordconfirm: [
          {
            trigger: "change",
            validator: this.conPassValidator,
          },
        ],
      },
    };
  },
  metaInfo: {
    title: "Reset or change your password Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Forgot Password? Follow the quick steps to reset your password. Login to Caregiver Saathi.",
      },
    ],
  },
  methods: {
    switchVisibility(val) {
      if (val === 1) {
        this.passwordFieldType1 =
          this.passwordFieldType1 === "password" ? "text" : "password";
      } else {
        this.passwordFieldType2 =
          this.passwordFieldType2 === "password" ? "text" : "password";
      }
    },
    conPassValidator(rule, value, callback) {
      if (value == "") {
        callback(new Error("Please Enter Confirm Password"));
      } else if (value != this.ruleForm.password) {
        callback(new Error("Password do not match"));
      } else {
        callback();
      }
    },
    async handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;

        if (valid) {
          this.forgotPassword();
        } else {
          return false;
        }
      });
    },
    async forgotPassword() {
      let passFormat =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&^])[A-Za-z\d@.#$!%*?&]{8,15}$/;
      if (!passFormat.test(this.ruleForm.password)) {
        this.$swal.fire({
          text: "Password must be Alpha-Numberic containing capital, small and special charaters",
          icon: "warning",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      const payload = {
        password: this.ruleForm.password,
        code: this.$route.query.urc,
        email: this.$route.query.uea,
        role: this.$route.query.role,
      };
      if (!this.role) {
        this.$swal.fire({
          text: "Invalid reset link: role not found",
          icon: "error",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
        });
        return;
      }

      try {
        if (this.ruleForm.password == this.ruleForm.Passwordconfirm) {
          const data = await this.$store.dispatch(
            "auth/passwordChange",
            payload
          );
          if (data.code == 200) {
            this.$swal.fire({
              text: "Password changed Successfully",
              icon: "success",
              confirmButtonText: "Okay",
              confirmButtonColor: "#830c81",
              showCancelButton: false,
            });
          }

          this.$router.push({ name: "signin" });
          window.localStorage.setItem("forgotPassword", true);
        } else {
          this.$swal.fire({
            text: "Password Does not Match",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });

          return;
        }
      } catch (error) {
        if ("Error") {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },
    async backtologin() {
      this.$router.push({ name: "signin" });
    },
  },
  components: {
    OTP,
  },
  mounted() {
    // console.log(this.$route.query.code);
  },
};
</script>

<style>
.login-tabs-container {
  min-height: 505px;
}
.cust-divider3 {
  border-bottom: 3px solid #e9ecef;
}
.fullpage-bgcolor {
  background-color: #eff2f7;
}
.bor {
  border: 1px solid rgba(155, 154, 154, 0.623);
}
.p-4 {
  padding: 1rem;
  background-color: #eff2f7;
}
</style>
